var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCopyLink = function SvgCopyLink(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M6.772 5.23a2.184 2.184 0 0 0-3.088 0L2.14 6.772a2.184 2.184 0 0 0 3.088 3.089L6 9.09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M5.228 6.772a2.184 2.184 0 0 0 3.088 0l1.545-1.544A2.184 2.184 0 1 0 6.772 2.14L6 2.912"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCopyLink);
export { ForwardRef as ReactComponent };